import React from 'react';

const DueTodayIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M10.5 5H1.5M8 1V3M4 1V3M3.9 11H8.1C8.94008 11 9.36012 11 9.68099 10.8365C9.96323 10.6927 10.1927 10.4632 10.3365 10.181C10.5 9.86012 10.5 9.44008 10.5 8.6V4.4C10.5 3.55992 10.5 3.13988 10.3365 2.81901C10.1927 2.53677 9.96323 2.3073 9.68099 2.16349C9.36012 2 8.94008 2 8.1 2H3.9C3.05992 2 2.63988 2 2.31901 2.16349C2.03677 2.3073 1.8073 2.53677 1.66349 2.81901C1.5 3.13988 1.5 3.55992 1.5 4.4V8.6C1.5 9.44008 1.5 9.86012 1.66349 10.181C1.8073 10.4632 2.03677 10.6927 2.31901 10.8365C2.63988 11 3.05992 11 3.9 11Z"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const RespondTodayIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M3.75 5.25H3.755M6 5.25H6.005M8.25 5.25H8.255M3.5 9V10.1678C3.5 10.4342 3.5 10.5674 3.55461 10.6358C3.60211 10.6953 3.67413 10.7299 3.75027 10.7298C3.83781 10.7297 3.94184 10.6465 4.14988 10.4801L5.34261 9.52592C5.58626 9.33099 5.70808 9.23353 5.84374 9.16423C5.9641 9.10274 6.09221 9.0578 6.22461 9.03063C6.37383 9 6.52985 9 6.84187 9H8.1C8.94008 9 9.36012 9 9.68099 8.83651C9.96323 8.6927 10.1927 8.46323 10.3365 8.18099C10.5 7.86012 10.5 7.44008 10.5 6.6V3.9C10.5 3.05992 10.5 2.63988 10.3365 2.31901C10.1927 2.03677 9.96323 1.8073 9.68099 1.66349C9.36012 1.5 8.94008 1.5 8.1 1.5H3.9C3.05992 1.5 2.63988 1.5 2.31901 1.66349C2.03677 1.8073 1.8073 2.03677 1.66349 2.31901C1.5 2.63988 1.5 3.05992 1.5 3.9V7C1.5 7.46499 1.5 7.69748 1.55111 7.88823C1.68981 8.40587 2.09413 8.81019 2.61177 8.94889C2.80252 9 3.03501 9 3.5 9ZM4 5.25C4 5.38807 3.88807 5.5 3.75 5.5C3.61193 5.5 3.5 5.38807 3.5 5.25C3.5 5.11193 3.61193 5 3.75 5C3.88807 5 4 5.11193 4 5.25ZM6.25 5.25C6.25 5.38807 6.13807 5.5 6 5.5C5.86193 5.5 5.75 5.38807 5.75 5.25C5.75 5.11193 5.86193 5 6 5C6.13807 5 6.25 5.11193 6.25 5.25ZM8.5 5.25C8.5 5.38807 8.38807 5.5 8.25 5.5C8.11193 5.5 8 5.38807 8 5.25C8 5.11193 8.11193 5 8.25 5C8.38807 5 8.5 5.11193 8.5 5.25Z"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ResolveTodayIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M3.75 6L5.25 7.5L8.25 4.5M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { DueTodayIcon, RespondTodayIcon, ResolveTodayIcon };
